import * as types from '../../action-types';
import { editCycle as initialState } from '../initialStates';

const editCycle = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.EDIT_CYCLE_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.EDIT_CYCLE_SUCCESS:
            return {
                ...state,
                isSuccessful: true,
                data: payload,
            }
        case types.EDIT_CYCLE_FAIL:
            return {
                ...state,
                error: payload
            }
        case types.EDIT_CYCLE_CLEANUP:
            return {
                ...state,
                error: null,
                isSuccessful: false
            }
        default:
            return state;
    };
};

export default editCycle;

